module.exports = "//static.hsappstatic.net/signup-ui/static-7.1120/images/internationalized-marketing-email/marketing-free-email-fr.png"